const CDN = 'https://cdn.geofleet.in/images';

/**
 * One image + icon per lifecycle step, in the same order as `howItWorksPage.steps`.
 * Shared by the How it works page and the homepage lifecycle strip.
 */
export const STEP_VISUALS = [
  { img: `${CDN}/how-it-works:upload-orders.png`, icon: 'ri-upload-cloud-2-line' },
  { img: `${CDN}/how-it-works:optimize-routes.png`, icon: 'ri-route-line' },
  { img: `${CDN}/how-it-works:dispatch-to-driver.png`, icon: 'ri-send-plane-line' },
  { img: `${CDN}/how-it-works:route-adjustments.png`, icon: 'ri-map-pin-time-line' },
  { img: '/images/how-it-works/tracking-url.png', icon: 'ri-message-3-line' },
  { img: `${CDN}/how-it-works:proof-of-delivery.png`, icon: 'ri-shield-check-line' },
] as const;
